import React from 'react';
import Popover from 'react-bootstrap/lib/Popover';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';

const Radio = (p) => {
  return (
    <label className="label-normal">
      <input type="radio" name={p.name} value={p.value} checked={p.selected} onChange={p.onChange} disabled={p.disabled} />
      {p.error ? <span className="validationMessage"> Select one of the options </span> : null}
      {` ${p.title} `}
      {p.info ?
        <OverlayTrigger trigger={['hover', 'focus']} placement={screen.width > 520 ? "right" : "top"} overlay={(<Popover id={`${p.name}-${p.value}`}>{p.info}</Popover>)}>
          <i className="fa fa-info-circle info-icon" />
        </OverlayTrigger>
        : null}
    </label>
  );
};

export default Radio;